import { Injectable, inject } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { debounceTime, first, map, switchMap } from 'rxjs/operators';
import { Category, CategoryStat } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class DashboardCategoryService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  public getMoreCategories = new Subject<{
    limit: number,
    offset: number,
    searchQuery?: string,
    displayHidden?: boolean,
    dateRangeStart?: Date,
    dateRangeEnd?: Date,
  }>();

  getCategoryList(eventId: number): Observable<{rows: CategoryStat[], count: number}> {
    const route = `${this.configUrl}e/o/categories/${eventId.toString()}`;
    return this.getMoreCategories.pipe(
      // wait 600ms after each keystroke before considering the term
      debounceTime(600),
      // switch to new search observable each time the term changes
      switchMap( ({limit, offset, searchQuery, displayHidden, dateRangeStart, dateRangeEnd}) => {
        const params = new HttpParams({
          fromObject: {
            limit: limit.toString(),
            offset: offset.toString(),
            searchQuery: encodeURIComponent(searchQuery.toString()),
            displayHidden,
            dateRangeStart: (dateRangeStart ? dateRangeStart.getTime() : ''),
            dateRangeEnd: ( dateRangeEnd ? dateRangeEnd.getTime() : ''),
          },
        });
        return this.http.get<{rows: CategoryStat[], count: number}>(route, {params});
      }),
    );
  }

  updateCategory(category: Category) {
    const route = `${this.configUrl}e/o/categories/${category.eventId}`;

    return this.http.put(route, category).pipe(
      first(),
    );
  }

  getCategoryPrepress(category: Category) {
    const route = `${this.configUrl}e/o/${category.eventId}/prepress/${category.id}`;
    return this.http.get<{
      fixedLength: string,
      randomLenght: string,
      // eslint-disable-next-line id-denylist
      number: string,
      hash: string,
      pdf: any
    }>(route);
  }

  exportCategoriesData(filters, eventId: number): Observable<ArrayBuffer> {
    const route = `${this.configUrl}e/o/categories/${eventId.toString()}`;
    const params = new HttpParams({
      fromObject: {
        format: 'csv',
        displayHidden: filters.displayHidden,
        searchQuery: filters.searchQuery ? encodeURIComponent(filters.searchQuery.toString()) : '',
        dateRangeStart: filters.dateRangeStart ? filters.dateRangeStart.toString() : '',
        dateRangeEnd: filters.dateRangeEnd ? filters.dateRangeEnd.toString() : '',
      },
    });
    return this.http.get(route, {params, responseType: 'arraybuffer'}).pipe(
      map((file: ArrayBuffer) => file),
    );
  }

}
